import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-please-verify',
  imports: [],
  templateUrl: './please-verify.component.html',
})
export class PleaseVerifyComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);

  userEmail: string | null = null;
  isResending = false;
  resentMessage: string | null = null;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    // DÉTAILS: On récupère l'email de l'utilisateur qui vient de s'inscrire.
    // L'AuthService le stocke temporairement pour ce genre de cas.
    this.userEmail = this.authService.getPendingVerificationEmail();
  }

  resendVerificationEmail(): void {
    if (!this.userEmail) {
      this.resentMessage =
        'Impossible de retrouver votre email. Veuillez vous réinscrire.';
      return;
    }

    this.isResending = true;
    this.resentMessage = null;

    this.authService.resendVerification(this.userEmail).subscribe({
      next: () => {
        this.isResending = false;
        this.resentMessage = 'Un nouvel e-mail de vérification a été envoyé.';
        this.cdr.markForCheck();
      },
      error: () => {
        this.isResending = false;
        this.resentMessage = 'Une erreur est survenue. Veuillez réessayer.';
        this.cdr.markForCheck();
      },
    });
  }
}
